import React, { useContext, useEffect } from 'react';
import { LanguageContext } from "../../context/LanguageContext";

const DevSection = () => {
  const { componentLanguageData, loadLanguageFile, language } = useContext(LanguageContext);

  useEffect(() => {
    loadLanguageFile("DevSection", "product_lib/product_lib_lang");
  }, [language]);

  const LANGUAGE = componentLanguageData.DevSection || { Main: {} };

  return (
    <div className="container-fluid py-5">
      <div className="container">
        <div className="row g-5 align-items-center">
          <div className="col-lg-6 wow fadeIn" data-wow-delay="0.1s">
            <div className="lib-img">
              <img className="img-fluid" src="img/dev-img2.jpg" alt="dev-img" />
            </div>
          </div>
          <div className="col-lg-6 wow fadeIn" data-wow-delay="0.5s">
            <div className="btn border rounded-pill text-primary px-3 mb-3">{LANGUAGE.Main.Content1}</div>
            <h1 className="mb-4">{LANGUAGE.Main.Content2}</h1>
            <p className="mb-4">{LANGUAGE.Main.Content3}</p>
            <p>{LANGUAGE.Main.Content4}</p>
            <p className="mb-4">{LANGUAGE.Main.Content5}</p>
            <ul>
              <li>{LANGUAGE.Main.List1}</li>
              <li>{LANGUAGE.Main.List2}</li>
              <li>{LANGUAGE.Main.List3}</li>
              <li>{LANGUAGE.Main.List4}</li>
            </ul>
            <p>{LANGUAGE.Main.Content6}</p>
            <div className="row g-3">
              <div className="col-sm-6">
                <h6 className="mb-3">
                  <i className="fa fa-check text-primary me-2"></i>{LANGUAGE.Main.Point1}
                </h6>
                <h6 className="mb-3">
                  <i className="fa fa-check text-primary me-2"></i>{LANGUAGE.Main.Point4}
                </h6>
              </div>
              <div className="col-sm-6">
                <h6 className="mb-3">
                  <i className="fa fa-check text-primary me-2"></i>{LANGUAGE.Main.Point2}
                </h6>
                <h6 className="mb-3">
                  <i className="fa fa-check text-primary me-2"></i>{LANGUAGE.Main.Point3}
                </h6>
              </div>
            </div>
            <div className="d-flex align-items-center mt-4">
              <a className="btn btn-primary rounded-pill px-4 me-3" href="#mas_lib">
                {LANGUAGE.Main.CTA}
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DevSection;
